import { BaseTheme as Theme } from '@blockanalitica/ui/package/types/src/theme/baseTheme';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function tableRow(theme: Theme): ComponentStyle {
  return {
    componentName: 'tableRow',
    baseStyle: {},
    variants: {
      link: {
        ['&:hover > div']: {
          backgroundColor: theme.colors.tableRowHover,
          color: theme.colors.text
        }
      }
    }
  };
}
